/* Eye On Ball: open the cart drawer for every add-to-cart button.
   Covers forms that post to /cart/add outside the theme's product form
   (collection grid, Better Together, Recommended add-on), the homepage
   "Add Both to Cart" strip, and the bb-product-card buttons.
   If anything fails, it falls back to the button's normal behavior. */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.style.opacity = busy ? '0.6' : '';
  }

  function addToDrawer(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Could not add to cart');
          err.handled = true;
          throw err;
        }
        return data;
      });
    }).then(function (data) {
      var drawer = getDrawer();
      if (!drawer || !data.sections || !data.sections['cart-drawer']) {
        window.location.href = '/cart';
        return;
      }
      drawer.renderContents({ id: data.id || null, sections: data.sections });
    });
  }

  function showError(btn, message) {
    if (!btn) { window.alert(message); return; }
    var original = btn.getAttribute('data-eob-label') || btn.innerHTML;
    btn.setAttribute('data-eob-label', original);
    btn.innerHTML = '<span>' + message.replace(/</g, '&lt;') + '</span>';
    setTimeout(function () {
      btn.innerHTML = original;
      btn.removeAttribute('data-eob-label');
    }, 2500);
  }

  function itemsFromForm(form) {
    var items = [];
    var action = (form.getAttribute('action') || '').split('?')[0];

    if (/\/cart\/add$/.test(action)) {
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (id && id.value) items.push({ id: Number(id.value), quantity: qty ? Math.max(1, Number(qty.value) || 1) : 1 });
    } else if (/\/cart$/.test(action)) {
      form.querySelectorAll('input[name^="updates["]').forEach(function (input) {
        var m = input.name.match(/^updates\[(\d+)\]$/);
        var q = Number(input.value) || 0;
        if (m && q > 0) items.push({ id: Number(m[1]), quantity: q });
      });
    }
    return items;
  }

  function isHandledByTheme(form) {
    return !!(
      form.closest('product-form') ||
      form.closest('cart-drawer') ||
      form.closest('cart-notification') ||
      form.getAttribute('data-type') === 'add-to-cart-form' ||
      form.classList.contains('installment')
    );
  }

  // Forms: plain /cart/add posts and the homepage "Add Both" strip
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !getDrawer()) return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    var isAdd = /\/cart\/add$/.test(action);
    var isBundle = /\/cart$/.test(action) && form.classList.contains('bb-hero-split__strip-form');
    if (!(isAdd || isBundle) || isHandledByTheme(form)) return;

    var items = itemsFromForm(form);
    if (!items.length) return;

    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    setBusy(btn, true);
    addToDrawer({ items: items, sections: SECTIONS, sections_url: window.location.pathname })
      .catch(function (err) {
        if (err && err.handled) { showError(btn, err.message); }
        else { form.submit(); }
      })
      .finally(function () { setBusy(btn, false); });
  }, true);

  // Product-card buttons (homepage lineup, Training page, drill articles)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bb-product-card__btn');
    if (!btn || !btn.dataset.variantId || !getDrawer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    setBusy(btn, true);
    addToDrawer({
      items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .catch(function (err) { showError(btn, err && err.handled ? err.message : 'Error, try again'); })
      .finally(function () { setBusy(btn, false); });
  }, true);
})();
